import { api } from "lib/graphql/api"
import { query } from "lib/graphql/query"
import { gql } from "@apollo/client"

export const getAuthoringGlobalRoles = api(({ skip = 0, take = 20, orderStmt, client } = {}) =>
    query(
        gql`
            query GetAuthoringGlobalRoles($skip: Int, $take: Int, $orderStmt: [String], $client: String) {
                getAuthoringGlobalRoles(skip: $skip, take: $take, orderStmt: $orderStmt, client: $client) {
                    id
                    name
                    description
                    demands
                }
            }
        `,
        { skip, take, orderStmt, client },
        { returns: "getAuthoringGlobalRoles" }
    )
)
